'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

declare global {
  interface Window {
    goto: (url: string) => void
  }
}

export function AppHandler(): JSX.Element {
  const router = useRouter()

  useEffect(() => {
    window.goto = (url: string) => {
      console.log('received window.goto', url)

      try {
        router.push(url)
      } catch (error) {
        console.warn('Invalid URL passed to window.goto', error)
      }
    }
  }, [router])

  return <></>
}
